import { Action } from 'redux';
import { getApi } from '../api/ApiProvider';
import initialState from '../initialState';
import { Product } from '../api/model';
import { NotificationActions } from './notification/notification-actions';
import { AppDispatch } from './index';
import { default as StoreModel, LoadedResource, LoadedSingleResource } from './StoreModel';


export enum ProductActionTypes {
	FETCH_REQUEST = '[PRODUCT][LIST] Request',
	FETCH_RESPONSE = '[PRODUCT][LIST] Response',
	FETCH_ERROR = '[PRODUCT][ERROR] Error',

	SAVE_REQUEST = '[PRODUCT][SAVE] Request',
	SAVE_RESPONSE = '[PRODUCT][SAVE] Response',
	SAVE_ERROR = '[PRODUCT][SAVE] Error',

	UPLOAD_IMAGE_REQUEST = '[PRODUCT][UPLOAD_IMAGE] Request',
	UPLOAD_IMAGE_RESPONSE = '[PRODUCT][UPLOAD_IMAGE] Response',
	UPLOAD_IMAGE_ERROR = '[PRODUCT][UPLOAD_IMAGE] Error',

	DISABLE_REQUEST = '[PRODUCT][DISABLE] Request',
	DISABLE_RESPONSE = '[PRODUCT][DISABLE] Response',
	DISABLE_ERROR = '[PRODUCT][DISABLE] Error',

}

export interface IProductStore {
	data: LoadedResource<Product>,
	abm: LoadedSingleResource<Product>,
	disable: LoadedSingleResource<Product>,
}

export default function reductor(
	state: IProductStore = initialState.product,
	action: Action<ProductActionTypes> & { payload: any }): IProductStore {

	if (!action) {
		return state;
	}

	switch (action.type) {
		case ProductActionTypes.FETCH_REQUEST:
			return {
				...state,
				data: StoreModel.fetching()
			};

		case ProductActionTypes.FETCH_RESPONSE:
			return {
				...state,
				data: StoreModel.result(action.payload)
			};

		case ProductActionTypes.FETCH_ERROR:
			return {
				...state,
				data: StoreModel.error(action.payload)
			};

		case ProductActionTypes.SAVE_REQUEST:
			return { ...state, abm: StoreModel.fetchingSingle() };

		case ProductActionTypes.SAVE_RESPONSE:
			return { ...state, abm: StoreModel.resultSingle(action.payload) };

		case ProductActionTypes.SAVE_ERROR:
			return { ...state, abm: StoreModel.errorSingle(action.payload) };

		case ProductActionTypes.DISABLE_REQUEST:
			return { ...state, disable: StoreModel.fetchingSingle() };

		case ProductActionTypes.DISABLE_RESPONSE:

			const id = action.payload.id;
			return {
				...state,
				disable: StoreModel.resultSingle(action.payload),
				data: {
					...state.data,
					data: state.data.data.map(d => d.id === id ? action.payload : d)
				}
			};
		case ProductActionTypes.DISABLE_ERROR:
			return { ...state, disable: StoreModel.errorSingle(action.payload) };

		case ProductActionTypes.UPLOAD_IMAGE_REQUEST:
			return { ...state, abm: StoreModel.fetchingSingle() };

		case ProductActionTypes.UPLOAD_IMAGE_RESPONSE:
			return { ...state, abm: StoreModel.resultSingle(action.payload) };

		case ProductActionTypes.UPLOAD_IMAGE_ERROR:
			return { ...state, abm: StoreModel.errorSingle(action.payload) };

		default:
			return state;
	}
};

export class ProductActions {


	save(companyId: number, data: any) {
		return (dispatch: AppDispatch) => {
			const notif = new NotificationActions();

			dispatch({ type: ProductActionTypes.SAVE_REQUEST });

			getApi().product().save(companyId, data).then(response => {
				dispatch(notif.addSuccess('Categoria', 'Categoria guardada'));
				dispatch({ type: ProductActionTypes.SAVE_RESPONSE, payload: response });
				dispatch(this.fetch(companyId));
			}).catch(err => {
				dispatch(notif.addError('Categoria', 'Fallo al guardar'));
				dispatch({ type: ProductActionTypes.SAVE_ERROR, payload: err });
			})

		}
	}

	uploadImage(companyId: number, productId: number, image: File) {
		return (dispatch: AppDispatch) => {
			const notif = new NotificationActions();

			dispatch({ type: ProductActionTypes.SAVE_REQUEST });

			getApi().product().addPhoto(companyId, productId, image).then(response => {
				dispatch(notif.addSuccess('Categoria', 'Imagen guardada'));
				dispatch({ type: ProductActionTypes.UPLOAD_IMAGE_RESPONSE, payload: response });
				dispatch(this.fetch(companyId));
			}).catch(err => {
				dispatch(notif.addError('Categoria', 'Fallo al guardar imagen'));
				dispatch({ type: ProductActionTypes.UPLOAD_IMAGE_ERROR, payload: err });
			})

		}
	}

	disable(companyId: number, productId: number) {
		const notif = new NotificationActions();
		return (dispatch: AppDispatch) => {
			getApi().product().disable(companyId, productId).then((data: any) => {
				dispatch(notif.addSuccess('Categoria', 'Categoria deshabilitada'));
				dispatch({ type: ProductActionTypes.DISABLE_RESPONSE, payload: data });
			}).catch(err => {
				dispatch({ type: ProductActionTypes.DISABLE_ERROR, payload: err });
			});
			return dispatch({ type: ProductActionTypes.DISABLE_REQUEST });

		}
	}

	fetch(companyId: number) {
		return (dispatch: AppDispatch) => {
			dispatch({ type: ProductActionTypes.FETCH_REQUEST });
			getApi().product().list(companyId).then(data => {
				dispatch({ type: ProductActionTypes.FETCH_RESPONSE, payload: data });
			}).catch(err => {
				dispatch({ type: ProductActionTypes.FETCH_ERROR, payload: err });
			});
		}
	}

	filter(companyId: number, search: string, filter: string) {
		return (dispatch: AppDispatch) => {
			dispatch({ type: ProductActionTypes.FETCH_REQUEST });
			getApi().product().filter(companyId, search, filter).then(data => {
				dispatch({ type: ProductActionTypes.FETCH_RESPONSE, payload: data });
			}).catch(err => {
				dispatch({ type: ProductActionTypes.FETCH_ERROR, payload: err });
			});
		}
	}

}



// WEBPACK FOOTER //
// ./src/store/product.ts